import type { Breakpoint } from "@core-ui/constants/breakpoints";

export const breakpointClassNames: Record<Breakpoint, string> = {
	sm: [
		"[&_:is(.groups,.top-menu,.bottom-info)]:max-w-full [&_:is(.groups,.top-menu,.bottom-info)]:px-4",
		"[&_.group-container]:gap-5 [&_.group-content]:grid-cols-2 [&_.group-content]:gap-3",
		"[&_.top-shadow]:top-[calc(3.25rem+var(--home-titlebar-offset))] [&_.bottom-info]:!flex-col",
		"[&_[data-card]]:min-w-[165px]",
	].join(" "),
	md: [
		"[&_:is(.groups,.top-menu,.bottom-info)]:max-w-[902px] [&_:is(.groups,.top-menu,.bottom-info)]:px-6",
		"[&_.group-container]:gap-5 [&_.group-content]:grid-cols-4 [&_.group-content]:gap-3",
		"[&_.top-shadow]:top-[calc(3.25rem+var(--home-titlebar-offset))]",
		"[&_[data-card]]:min-w-[171px]",
	].join(" "),
	lg: [
		"[&_:is(.groups,.top-menu,.bottom-info)]:max-w-[1173px] [&_:is(.groups,.top-menu,.bottom-info)]:px-9",
		"[&_.group-container]:gap-6 [&_.group-content]:grid-cols-4 [&_.group-content]:gap-4",
		"[&_.top-shadow]:top-[calc(3.7rem+var(--home-titlebar-offset))]",
		"[&_[data-card]]:min-w-[188px]",
	].join(" "),
	xl: [
		"[&_:is(.groups,.top-menu,.bottom-info)]:max-w-[1144px] [&_:is(.groups,.top-menu,.bottom-info)]:px-9",
		"[&_.group-container]:gap-6 [&_.group-content]:grid-cols-4 [&_.group-content]:gap-4",
		"[&_.top-shadow]:top-[calc(3.7rem+var(--home-titlebar-offset))]",
		"[&_[data-card]]:min-w-[188px]",
	].join(" "),
	"2xl": [
		"[&_:is(.groups,.top-menu,.bottom-info)]:max-w-[1144px] [&_:is(.groups,.top-menu,.bottom-info)]:px-9",
		"[&_.group-container]:gap-6 [&_.group-content]:grid-cols-4 [&_.group-content]:gap-4",
		"[&_.top-shadow]:top-[calc(3.7rem+var(--home-titlebar-offset))]",
		"[&_[data-card]]:min-w-[188px]",
	].join(" "),
};
